import React, { Dispatch, useReducer } from 'react';

import BaselineAffectationReducers from './_reducers/AffectationReducer';
import { PossiblesBaselineAffectationActions } from './BaselineAffectationReducers';
import { InitialStateType, initialValue } from './helperContext';

export type AffectationSearch = {
  workunit_name: string;
  workunit_reference: string;
  complexity_name: string;
  consultant_fullname: string;
  client_fullname: string;
  forecast_date: string;
  delivery_date: string;
  scope_id?: number;
};

const BaselineAffectationContext = React.createContext<{
  state: InitialStateType;
  dispatch: Dispatch<PossiblesBaselineAffectationActions>;
}>({
  state: initialValue,
  dispatch: () => null,
});
// BaselineAffectationContext.displayName = 'BaselineAffectationContext';

const BaselineAffectationProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(BaselineAffectationReducers as any, initialValue);

  return (
    <BaselineAffectationContext.Provider value={{ state, dispatch }}>{children}</BaselineAffectationContext.Provider>
  );
};
export { BaselineAffectationProvider, BaselineAffectationContext };
